import React from 'react'

export const DisenoWebPalermo = () => {
    return (
        <main className="margen1 bg-[#EEF2FF] dark:bg-[#050817]">
            {/* Título principal con keyword exacta */}
            <section className="mb-3">
                <h1 className="titulo1 text-center mb-[3rem]">
                    Diseño de Páginas Web en Palermo | Power Bit
                </h1>
                <p className="!font-medium !leading-5">
                    En Power Bit nos especializamos en <strong>diseño de páginas web en Palermo</strong> para profesionales, marcas y emprendimientos que buscan destacar online. Creamos sitios personalizados, rápidos y funcionales, pensados para el público local y regional.
                </p>
            </section>

            {/* Servicios con keyword en subtítulo */}
            <section className="mb-3">
                <h2 className="lg:text-3xl text-xl font-bold mb-3">
                    Servicios de Diseño de Páginas Web en Palermo
                </h2>
                <ul className="!font-medium !leading-5 list-disc list-inside">
                    <li>
                        <strong>Diseño web personalizado</strong> para negocios de Palermo, con enfoque en usabilidad y conversión.
                    </li>
                    <li>
                        <strong>Publicidad digital</strong> para potenciar tu sitio web en redes sociales y buscadores.
                    </li>
                    <li>
                        <strong>Marketing estratégico</strong> para posicionar tu página web en Palermo y atraer clientes reales.
                    </li>
                </ul>
            </section>

            {/* Identidad local reforzada */}
            <section className="mb-3">
                <h2 className="lg:text-3xl text-xl font-bold mb-3">
                    Agencia de Diseño de Páginas Web en Palermo, Buenos Aires
                </h2>
                <p className="!font-medium !leading-5">
                    Somos una agencia con base en Palermo, especializada en <strong>diseño de páginas web</strong> que conectan con tu audiencia. Conocemos el ritmo de los negocios locales y ofrecemos soluciones digitales que funcionan. Si buscás una agencia cercana, profesional y con resultados, estás en el lugar indicado.
                </p>
            </section>

            {/* CTA con enlaces en lista tabulada */}
            <section className="mb-3">
                <h2 className="lg:text-3xl text-xl font-bold mb-3">
                    ¿Querés impulsar tu diseño de página web en Palermo?
                </h2>
                <p className="!font-medium !leading-5 mb-5">
                    En Power Bit convertimos ideas en experiencias digitales. Elegí cómo querés avanzar:
                </p>
                <ul className="list-disc list-inside pl-4 !font-medium !leading-5">
                    <li>
                        <a
                            href="https://powerbit.com.ar/#contacto"
                            className="underline font-semibold underline-offset-4 dark:font-medium decoration-[#274dd8] dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600"
                        >
                            Ir a contacto
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://powerbit.com.ar/#planes"
                            className="underline font-semibold underline-offset-4 dark:font-medium decoration-[#274dd8] dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600"
                        >
                            Solicitar presupuesto
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://powerbit.com.ar/#portafolio"
                            className="underline font-semibold underline-offset-4 dark:font-medium decoration-[#274dd8] dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600"
                        >
                            Ver portafolio de clientes
                        </a>
                    </li>
                </ul>
            </section>
        </main>
    )
}